/**=========================================================
 * Module: prices.js
 * Prices Controller
 =========================================================*/

 App.controller("PricesController", ["$rootScope", "$scope", "$state", "$translate", "$window", "$localStorage", "$timeout", "toggleStateService", "Restangular", "DataService", '$http', '$filter',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $http, $filter) 
 {
   "use strict";

   $scope.id = $state.params.filter.split('-');

   $scope.clientId =  $scope.id[0]
   $scope.supplierId = $scope.id[1]
   $scope.source = $scope.id[2] || null
   $scope.target = $scope.id[3] || null

   $scope.load = function (range, cursor) {
     var filter = 'client=' + $scope.clientId + '&supplier=' + $scope.supplierId;
     if (cursor) {
       if (filter) filter += '&';
       filter += '_cursor=' + cursor;
     }
     if (filter) filter += '&';
     filter += '_range=' + range;
     if (!cursor) $scope.data = [];
     $scope.loading = true;
     D.query('price', filter, { cache: false }).then(
       function (response) {
         for (var i = 0; i < response.length; i++){
           $scope.data.push(response[i]);
           $scope.data.sort(function(a, b){
             return a.source > b.source ? 1 : -1 //todo mettere traduzioni
           })
         }
         $scope.lastCursor = response.cursor;

         if (response.length === range && response.cursor) {
           $scope.load(100, response.cursor);
         } else {
           $scope.loading = false;
         }
       },
       function (error) {
         $scope.error = error;
         $scope.loading = false;
       }
     ).catch(console.error);
   };
  
   
   D.load('group', $scope.clientId, { cache: false }).then(function(response){
       $scope.client = response
       D.load('group', $scope.supplierId, { cache: false }).then(function(response){
            $scope.supplier = response

            $scope.page = {
                title: 'labels.PRICELISTS',
                subTitle: $scope.client.name + ' - ' + $scope.supplier.name
              };

            D.query('language', '', { cache: false }).then(function(response){
              $scope.languages = response
            }).catch(console.error)

            $scope.load(50, '', 1);
       }).catch(console.error)

       D.load('reference', $scope.clientId + '-' + $scope.supplierId, { cache: false }).then(function (response) {
         $scope.reference = response
         $scope.priceListSettingsForm = {
           title: 'labels.SETTINGS',
           status: '',
           type: 'reference',
           model: $scope.reference,
           fields: [{
             available: true,
             type: 'checkbox',
             name: 'automaticOffer',
             column: 6
           }, {
            available: true,
            type: 'number',
            name: 'automaticOfferThreshold',
            column: 6
          }, {
             available: true,
             type: 'submit',
             name: 'empty',
             label: 'labels.SAVE',
           }],
           submit: function () {
             $scope.priceListSettingsForm.status = 'submitting';
             $scope.priceListSettingsForm.model.action = 'SetAutomaticOffer'
             D.save('reference', $scope.priceListSettingsForm.model).then(function (resp) {
               $scope.priceListSettingsForm.status = 'submitted';
             }).catch(function () {
               $scope.priceListSettingsForm.status = 'error';
             })
           }
         }
       }).catch(console.error)

       $scope.exportCurrentPricesForm = {
        title: 'labels.EXPORTPRICESLIST',
        status: '',
        type: 'price',
        model: { },
        fields: [{
          available: true,
          type: 'button',
          noLabel: true,
          cls: 'btn-primary',
          label: 'labels.EXPORT',
          onClick: function(){
            $window.open($rootScope.app.config.baseUrl + '/price.xlsx/' + $scope.client.id + '-' + $scope.supplier.id + '-valued' + '?_filename=Listino_' + $scope.client.id + '-' + $scope.supplier.id + '&access_token=' + $rootScope.FB.token)
          }
        }]
      };

       $scope.exportPricesForm = {
        title: 'labels.GENERATEPRICESLIST',
        status: '',
        type: 'price',
        model: { sources: [], targets: [] },
        info: $filter('translate')('labels.GENERATEPRICELISTINFO'),
        fields: [{
          available: true,
          type: 'language',
          multiple: true,
          name: 'sources',
          placeholder: 'enums.language.*'
      },{
          available: true,
          type: 'language',
          multiple: true,
          name: 'targets',
          placeholder: 'enums.language.*'
      },{
          available: true,
          type: 'button',
          noLabel: true,
          cls: 'btn-primary',
          label: 'fields.GENERATE',
          onClick: function(){
            $window.open($rootScope.app.config.baseUrl + '/price.xlsx/' + $scope.client.id + '-' + $scope.supplier.id + '-' + $scope.exportPricesForm.model.sources + '!' + $scope.exportPricesForm.model.targets +'?_filename=Listino_' + $scope.client.id + '-' + $scope.supplier.id + '&access_token=' + $rootScope.FB.token)
          }
        }]
      };
  
      $scope.importPricesForm = {
        title: 'labels.IMPORTPRICESLIST',
        status: '',
        type: 'group',
        model: $scope.client,
        info: $filter('translate')('labels.IMPORTPRICELISTINFO'),
        fields: [{
          available: true,
          type: 'file',
          name: 'priceslist',
          canUpload: true,
          label: 'fields.UPLOAD',
          inputColumn: 12,
          limit: 1,
          allow: 'xls|xlsx',
          bucket: $rootScope.bucketName($scope.client.id)
        }, {
          available: true,
          type: 'submit',
          noLabel: true,
          name: 'empty',
          label: 'labels.IMPORT'
        }],
        submit: function () {
          $scope.importPricesForm.status = 'submitting';
          var file = $rootScope.files['group' + $scope.client.id + 'priceslist'][0]
          R.one('price', $scope.client.id + '-' + $scope.supplier.id)
            .customPUT({ action: 'ImportPrices', client: $scope.client.id, supplier: $scope.supplier.id, file: file.url, fileId: file.id})
            .then(function(resp){
                if(resp){
                  $scope.importPricesForm.status = '';
                  $state.go('app.entity', {action: 'list', type: 'prices', filter: $state.params.filter}, {reload: true})
                } else {
                  $scope.importPricesForm.status = 'error'
                }
            })
        }
      };
   })

   
   
   



}
]);
